/*=============================================== CardStyles styles ===============================================*/

import styled from "styled-components/macro"
import { Flexbox } from "tsx-library-julseb"

const SQUARE_SIZE = 120

export const Square = styled.span`
    width: ${SQUARE_SIZE}px;
    height: ${SQUARE_SIZE}px;
    display: inline-block;

    &.is-shadow {
        background-color: ${({ theme }) => theme.Background};
        box-shadow: var(--square-shadow);
    }

    &.is-radius {
        background-color: ${({ theme }) => theme.Danger100};
        border-radius: var(--square-radius);
        width: var(--square-width, ${SQUARE_SIZE}px);
    }

    &.is-spacer {
        width: var(--square-spacer);
        height: var(--square-spacer);
        background-color: ${({ theme }) => theme.Danger100};
    }
`

export const Content = styled(Flexbox)`
    align-self: stretch;
    row-gap: 0px;
`
